

export const GOODS_INFO = {

    2:{
        imgs:[
            require("../assets/imgs/goods/xiaoshuo/1.png"),
            require("../assets/imgs/goods/xiaoshuo/2.png"),
            require("../assets/imgs/goods/xiaoshuo/3.png"),
            require("../assets/imgs/goods/xiaoshuo/4.png"),
        ]
    },
    3:{
        imgs:[
            require("../assets/imgs/goods/gongzhumanghe/1.png"),
            require("../assets/imgs/goods/gongzhumanghe/2.png"),
            require("../assets/imgs/goods/gongzhumanghe/3.png"),
            require("../assets/imgs/goods/gongzhumanghe/4.png")
        ]
    },
    11:{
        imgs:[
            require("../assets/imgs/goods/pintu/1.jpg"),
            require("../assets/imgs/goods/pintu/2.jpg"),
            require("../assets/imgs/goods/pintu/3.jpg"),
        ]
    },
    13:{
        imgs:[
            require("../assets/imgs/goods/youxiji/1.jpg"),
            require("../assets/imgs/goods/youxiji/2.jpg"),
            require("../assets/imgs/goods/youxiji/3.jpg"),
        ]
    },
    1:{
        imgs:[
            require("../assets/imgs/goods/yinyuedeng/1.jpg"),
            require("../assets/imgs/goods/yinyuedeng/2.jpg"),
            require("../assets/imgs/goods/yinyuedeng/3.jpg"),
        ]
    },
    12:{
        imgs:[
            require("../assets/imgs/goods/legao/1.jpg"),
            require("../assets/imgs/goods/legao/2.jpg"),
            require("../assets/imgs/goods/legao/3.jpg"),
        ] 
    },
    4:{
        imgs:[
            require("../assets/imgs/goods/dishini/1.jpg"),
            require("../assets/imgs/goods/dishini/2.jpg"),
            require("../assets/imgs/goods/dishini/3.jpg"),
        ] 
    },
    14:{
        imgs:[
            require("../assets/imgs/goods/xunlonggaoshou/1.jpg"),
            require("../assets/imgs/goods/xunlonggaoshou/2.jpg"),
            require("../assets/imgs/goods/xunlonggaoshou/3.jpg"),
        ] 
    }
}


//////////////////
// WEBPACK FOOTER
// ./app/contants/goods.js
// module id = null
// module chunks = 